import axios from "axios";
import BaseService from "../config/baseService";
import {
  API_ADD_COMPLAINT,
  API_GET_COMPLAINT_CONFIG,
  API_GET_USER_COMPLAINTS
} from "../config/webService";

class ComplaintService extends BaseService {
  async getComplaintConfig() {
    const response = await axios.get(API_GET_COMPLAINT_CONFIG);
    return response && response.data;
  }

  async addComplaint(payload) {
    const response = await axios.post(API_ADD_COMPLAINT, payload);
    return response && response.data;
  }

  async getUserComplaints() {
    const response = await axios.get(API_GET_USER_COMPLAINTS);
    return response && response.data;
  }
}

export default new ComplaintService();
